import ComponentManifestBase from '../../../base/ComponentManifest.base';
import type { WixComponentManifest } from '../../../schema';
import type { ComponentManifestMergerConstructor } from './types';
import type { IMergerClass } from '../../componentManifestResolver.types';
import constants from '../../componentManifestResolver.constants';
import EditingBehaviorsMerger from '../EditingBehaviors/EditingBehaviors.merger';
import ElementsMerger from '../Elements/Elements.merger';
import StyleMerger from '../Style/Style.merger';

class ComponentManifestMerger implements IMergerClass<WixComponentManifest> {
  protected mainComponentManifest: ComponentManifestBase;
  protected referredComponentManifest: ComponentManifestBase;
  constructor({ manifest, referredManifest }: ComponentManifestMergerConstructor) {
    this.mainComponentManifest = new ComponentManifestBase(manifest);
    this.referredComponentManifest = new ComponentManifestBase(referredManifest || {});
  }

  public merge() {
    const mergeEditingBehaviors = new EditingBehaviorsMerger({
      mainEditingBehaviors: this.mainComponentManifest.getEditingBehaviors(),
      referredEditingBehaviors: this.referredComponentManifest.getEditingBehaviors()
    }).merge();

    const mergeStyle = new StyleMerger({
      mainStyle: this.mainComponentManifest.getStyle(),
      referredStyle: this.referredComponentManifest.getStyle()
    }).merge();

    const mergedElements = new ElementsMerger({
      mainElements: this.mainComponentManifest.getElements(),
      referredElements: this.referredComponentManifest.getElements()
    }).merge();

    const mergedManifest = new ComponentManifestBase();

    mergedManifest.setManifest({
      ...this.referredComponentManifest.getManifest(),
      ...this.mainComponentManifest.getManifest()
    });

    mergedManifest.setEditingBehaviors(mergeEditingBehaviors);
    mergedManifest.setStyle(mergeStyle);

    if (mergedElements) {
      mergedManifest.setElements(mergedElements);
    }

    const resolvedManifestObject = mergedManifest.getManifest();

    const { valid, errors } = ComponentManifestBase.validate(resolvedManifestObject);

    if (!valid) {
      throw new Error(
        constants.failedMergingError({
          errors: errors,
          mainManifest: this.mainComponentManifest.getManifest(),
          referredManifest: this.referredComponentManifest.getManifest()
        })
      );
    }

    return resolvedManifestObject;
  }
}

export default ComponentManifestMerger;
